<div
  class="chart-overall"
  [tooltip]="
    entityLevel === 'student' || entityLevel === 'usage'
      ? toolTipTemplate
      : null
  "
  container="body"
>
  <p
    class="number number_large"
    [style.color]="color"
    [ngClass]="{ mega_large_number: isMegaLargeNumber }"
    [class.student-overall-data]="
      entityLevel === 'student' || entityLevel === 'usage'
    "
  >
    <ng-container *ngIf="chartData[0].alphaValue">
      {{ chartData[0].alphaValue }}
    </ng-container>
    <ng-container *ngIf="!chartData[0].alphaValue">
      <span class="prefix_large" [style.color]="color">{{ dataPrefix }}</span>
      {{ chartData[0].y | number: "1." + roundTo + "-" + roundTo }}
      <span
        class="percentage-sign percent_large"
        [style.color]="color"
        [class.student-percentage-sign]="entityLevel === 'student'"
      >
        {{ dataSuffix }}
      </span>
    </ng-container>
  </p>
  <p
    *ngIf="
      (filterSentence || overallDescriptor === 'denominatorDescriptor') &&
      !(entityLevel === 'student' || entityLevel === 'usage')
    "
    class="denominator-descriptor-text"
  >
    {{ chartData[0].numerator | number }}
    <ng-container *ngIf="chartData[0].denominator">of</ng-container>
    {{ chartData[0].denominator | number }}
    {{ chartData[0].descriptor }}
    <img
      *ngIf="isFreckleMetric"
      [src]="'../../assets/images/no_data.png'"
      class="question-icon"
      [tooltip]="toolTipTemplate"
      container="body"
    />
  </p>
  <ng-container *ngIf="filterSentence">
    <p class="trend filter-sentence">
      {{ filterSentence }}
    </p>
  </ng-container>
  <ng-container
    *ngIf="
      (!filterSentence && overallDescriptor === 'changeDescriptor') ||
      entityLevel === 'student' ||
      entityLevel === 'usage'
    "
  >
    <p class="trend" *ngIf="chartData.length > 1 && entityLevel !== 'student'">
      <img [src]="partialImagePath + trendImg" class="trendImg" />
      <span>{{ getPositiveVal(trend) }} {{ trendSuffix }}</span>
      <span *ngIf="chartData[1].name"> from {{ chartData[1].name }}</span>
    </p>
    <p
      class="trend"
      *ngIf="
        !hideSubtitle &&
        chartData.length <= 1 &&
        entityLevel !== 'student' &&
        entityLevel !== 'usage'
      "
    >
      <span class="data-not-available">last year's data not available</span>
    </p>
    <p
      class="trend student-overall-subtitle"
      *ngIf="entityLevel === 'student' || entityLevel === 'usage'"
    >
      {{ overallSubtitle }}
    </p>
  </ng-container>
</div>
<div
  class="overall-descriptor-selector-div"
  *ngIf="!filterSentence && chartData.length > 1 && entityLevel !== 'student'"
>
  <!-- we only show if we haven't filtered and if we have change data -->
  <tile-view-carrousel
    [overallDescriptor]="overallDescriptor"
    (overallDescriptorChange)="overallDescriptor = $event"
  ></tile-view-carrousel>
</div>

<ng-template #toolTipTemplate>
  <div class="highcharts-tooltip">
    <span *ngIf="!isFreckleMetric">
      <div>
        <span class="metric-tooltip title tile_body">{{
          overallSubtitle
        }}</span>
        <span
          class="metric-tooltip value tooltip_value"
          [ngStyle]="{ color: chartData[0].color }"
        >
          <ng-container *ngIf="chartData[0].alphaValue">
            {{ chartData[0].alphaValue }}
          </ng-container>
          <ng-container *ngIf="!chartData[0].alphaValue">
            {{ dataPrefix
            }}{{ chartData[0].y | number: "1." + roundTo + "-" + roundTo
            }}{{ dataSuffix }}
          </ng-container>
        </span>
      </div>
      <div
        class="metric-tooltip description body_tooltip_text"
        [innerHTML]="toolTipText"
      ></div>
    </span>
    <span
      *ngIf="isFreckleMetric"
      class="metric-tooltip description body_tooltip_text freckle-metric-text"
      >Not seeing the number you expect? We only show students who were rostered
      through Renaissance.</span
    >
  </div>
</ng-template>
